<template>
    <div id="myOrder" :style="($route.query.noNavBar==='true')?{'padding-bottom': 0}:{}">
      <van-nav-bar
        fixed
        title="我的订单"
        :left-arrow="$route.query.noNavBar==undefined?false:true"
        @click-left="$router.go(-1);"
        @click-right="onClickRight" />
      <van-tabs offset-top="44" swipeable animated sticky v-model="active" title-active-color="#333333" color="#4BA4FB">
          <van-tab title="进行中">
            <template #default>
              <myOrderList :type="1"></myOrderList>
            </template>
          </van-tab>
          <van-tab title="待评价">
            <template #default>
              <myOrderList :type="2"></myOrderList>
            </template>
          </van-tab>
          <van-tab title="全部">
            <template #default>
              <myOrderList :type="3"></myOrderList>
            </template>
          </van-tab>
      </van-tabs>
    </div>
</template>

<script>
import Scroll from '@/config/scroll';
import myOrderList from './myOrderList';
export default {
    components: {
        myOrderList
    },
    name: 'MyOrder',
    mixins: [Scroll],
    data() {
        return {
            active:0
        };
    },
    methods: {
        onClickRight(){
            // console.log(123);
        }
    },
    created() {

    }
};
</script>
<style lang="scss">
    #myOrder{
      padding: 1.21rem 0;
      .van-tabs{
        .van-sticky{
          top: 1.21rem !important;
        }
      }
      .van-nav-bar{
        .van-icon-arrow-left{
          font-size: 25px;
          color: #000000;
        }
        .van-nav-bar__title{
          font-size:18px;
          font-family:PingFang SC;
          font-weight:bold;
          color:rgba(0,0,0,1);
        }
        .van-nav-bar__right{
          .van-nav-bar__text{
            font-size:15px;
            font-family:PingFang SC;
            font-weight:500;
            color:rgba(51,51,51,1);
          }
        }
      }
    }
</style>
